import { useMemo } from 'react';
import { format, isValid, parseISO } from 'date-fns';

export default function (date) {
  return useMemo(() => {
    if (!isValid(parseISO(date))) return null;
    return format(parseISO(date), 'dd/MM/yyyy');
  }, [date]);
}
